<template>
  <div v-show="newList.length > 0">
    <div class="n_list05">
      <ul>
        <li v-for="(item, index) in newList" :key="index" @click="shoDetial(item)">
          <div class="item">
            <time>
              <i class="line"></i>
              <span>{{ item.publish_time ? item.publish_time.substring(0, 7) : "--" }}</span>
              <em>{{ item.publish_time ? item.publish_time.substring(8, 10) : "--" }}</em>
            </time>
            <div class="time2">
              {{ item.publish_time ? item.publish_time.substring(0, 10) : "--" }}
            </div>
            <div class="img_zd">
              <img :src="item.title_img_path" />
            </div>
            <div class="con">
              <div class="tit">{{ item.article_title }}</div>
              <p>
                {{ item.article_desc }}
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>


  <!-- <div class="listOne">
    <div v-for="(item, index) in newList" :key="index" class="box-list clearfix" @click="shoDetial(item.article_id)">
      <div class="box-list-img fl">
        <img :src="item.dynamic_data.pictures" />
      </div>
      <div class="box-list-font fl">
        <div class="title over-one">{{ item.article_title }}</div>
        <div class="info over-two"> {{ item.article_desc }}</div>
        <div class="time"> 发表于：{{ item.publish_time }}</div>
      </div>
    </div>
    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div> -->
</template>
<script>
export default {
  props: {
    columnId: {
      type: String,
      default: '',

    }
  },
  data() {
    return {
      newList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: self.columnId,
        pageNo: self.currentPage,
        pageCount: self.pageSize
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data || []
            self.total = res.data.count
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    handleSizeChange() {

    },
    handleCurrentChange(item) {
      this.currentPage = item
      this.getList()
    },
    shoDetial(item) {
      this.$emit('detail', item)
    }
  },
  watch: { // 监听，当路由发生变化的时候执行

  }
};
</script>

<style lang="less" scoped>
/*新闻图片列表页*/
.n_list05 {
  // padding: 0 120px 50px 350px;
}

.n_list05 ul {
  margin: 0;
  padding: 0;
}

.n_list05 li {
  list-style: none;
}

.n_list05 li .item {
  padding: 30px 36px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  border: 2px solid transparent;
}

.n_list05 li time {
  display: block;
  width: 70px;
  color: #8c1c40;
  text-align: right;
}

.n_list05 li time i {
  display: block;
  height: 2px;
  background: #8c1c40;
  margin-bottom: 10px;

}

.n_list05 li time span {
  display: block;
  font-size: 18px;
  line-height: 1.5;
  opacity: .68;
  letter-spacing: -1px;
  margin-bottom: 10px;
}

.n_list05 li time em {
  display: block;
  font-size: 32px;
  line-height: 1.125;
  letter-spacing: -1px;
  text-align: right;
  font-family: 'HarmonyOS_Sans_SC_Bold';
  font-style: normal;
  font-weight: 900;
}

.n_list05 li .img_zd {
  width: 217px;
  height: 136px;
}

.n_list05 li img {
  width: 100%;
  height: 100%;
  padding-bottom: 136px;
}

.n_list05 li .con {
  // width: 70%;
  width: calc(100% - 335px);
  align-self: center;
}

.n_list05 li .tit {
  font-size: 24px;
  line-height: 1.25;
  color: #191919;
  font-family: 'HarmonyOS_Sans_SC_Light';
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 17px;
}

.n_list05 li .con p {
  font-size: 18px;
  line-height: 1.66;
  color: #a1a1a1;
  font-family: 'HarmonyOS_Sans_SC_Light';
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.n_list05 li * {
  transition: .5s ease;
}

.n_list05 li {
  margin-bottom: 45px;
}

.n_list05 li:hover .item {
  background: rgba(229, 236, 244, 0.6);
  border-color: #fff;
  box-shadow: 0 010px 30px rgba(0, 64, 152, 0.1);
}

.n_list05 li:hover time {
  color: #004098;
}

.n_list05 li:hover time span {
  opacity: 1;
}

.n_list05 li:hover time i {
  background: #004098;
}

.n_list05 li:hover .tit {
  color: #004098;
  font-family: 'HarmonyOS_Sans_SC_Regular';
}

.n_list05 li:hover .con p {
  color: #191919;
}

// a {
//   text-decoration: none;
// }

.page {
  text-align: center;
  margin-bottom: 40px;
}

@media screen and (min-width: 1025px) {
  .n_list05 li {

    time {
      display: block;
    }

    .time2 {
      display: none;
    }

  }
}

@media screen and (max-width: 1025px) {

  .n_list05 li {
    margin-bottom: 20px;

    .item {
      padding: 0;
      flex-direction: column;
    }

    time {
      display: none;
    }

    .time2 {
      display: block;
      font-size: 12px;
      color: #8c1c40;
      margin-bottom: 10px;
    }

    .img_zd {
      width: 100%;
      height: 240px;

      img {
        padding-bottom: 0px;
      }
    }

    .con {
      width: 100%;
      padding-top: 15px;

      .tit,
      p {
        font-size: 16px;
        margin: 10px 0;
      }

    }

  }

  .el-pagination {
    white-space: wrap;
    padding: 0;
    /deep/ .number,
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 5px !important;
      min-width: 20px !important;
    }
    /deep/ .el-pagination__jump{
      margin-left: 5px !important;
    }
  }
}
</style>